import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ThirdPartySource } from "../_types/third-party-source";

@Injectable({
    providedIn: 'root',
})
export class ThirdPartiesSourcesService extends Service<ThirdPartySource> {
    public override type = 'thirdPartySources';
    public override url = 'common/thirdPartiesSources';
}
